<form class="o-grid o-grid--wrap" name="vm.form" (ngSubmit)="vm.journeyNextStep()" autocomplete="off" novalidate *ngIf="!vm.showOnlyThankYouSection">
	<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
		<div class="o-grid">
			<div class="o-grid__cell u-no-p">
				<section class="c-section c-section--last"
						[ngClass]="{ 'c-section--error': vm.submitted && vm.stepInvalid }"
						panel 
						[isOpen]="true">
					<div class="c-section__header">
						<h2 class="c-section__title c-section__title--sm">{{ vm.headerText }}</h2>
					</div>
					<div class="c-section__content">
						<div class="o-grid">
							<div class="o-grid__cell u-no-p@up-to-md">
								<div class="c-card" [ngClass]="{ 'c-card--error': vm.submitted && vm.stepInvalid }">
									<div class="c-form" *ngIf="!vm.isSaving">
										<div class="c-content" style="min-height: 100px;">
											<div class="c-form__group u-osb-sm"
												*ngFor="let service of vm.serviceInfo | journeyStepFilter:vm.currentJourneyStep ; let $index=index"
												[ngClass]="{ 'c-form__group--error': vm.submitted && vm.stepInvalid }">
												<p *ngIf="service.type === 'TEXT'" [style]="service.customCssStyle" class="{{service.customCssClass}}">{{ service.label }}</p>
												<p *ngIf="service.type === 'TEXT_ERROR' && vm.submitted && vm.stepInvalid" class="c-text c-text--s3 {{service.customCssClass}}"
													 [style]="service.customCssStyle" [innerHtml]="vm.getSafeHtml(service.label)">
												</p>
												
												<div [ngClass]="{'c-form__group--error': (vm.submitted && vm.stepInvalid)}">												
													<label class="c-checkbox {{service.customCssClass}}" *ngIf="service.type === 'CHECKBOX'" 
														[style]="service.customCssStyle">
														<input type="checkbox" 
															[name]="service.fieldName" 
															[(ngModel)]="vm.selectedServiceIds[service.id]"
															[required]="vm.required[service.required]"
															(ngModelChange)="isStepInvalid()">
														<span id="serviceLabelText{{$index}}" [innerHtml]="vm.getSafeHtml(service.label)"></span>
													</label>
													<label class="c-radio {{service.customCssClass}}" *ngIf="service.type === 'RADIO'" 
														[style]="service.customCssStyle">
														<input type="radio" 
															[name]="'step' + service.step" 
															[id]="service.fieldName" 
															[(ngModel)]="radioSelectedValue"
															[required]="vm.required[service.required]"
															[value]="service.id"
															(ngModelChange)="onRadioChange(service.id)">
														<span id="serviceLabelText{{$index}}" [innerHtml]="vm.getSafeHtml(service.label)"></span>
													</label>
												</div>
												
												<button *ngIf="service.type === 'button'" [style]="service.customCssStyle" class="{{service.customCssClass}}">{{ service.label }}</button>
												
												<div *ngIf="service.type === 'TEXT_INPUT'" [style]="service.customCssStyle" class="{{service.customCssClass}}"
														 [ngClass]="{'c-form__group--error': (vm.submitted && vm.stepInvalid)}">
													<label [for]="service.fieldName" class="c-form__label u-osb-xs" [innerHtml]="vm.getSafeHtml(service.label)"></label>
													<textarea [id]="service.fieldName" [name]="service.fieldName" class="c-form__input"
																 [(ngModel)]="vm.selectedServiceIds[service.id]" [required]="vm.required[service.required]">
                                                    </textarea>
													<p class="c-text c-text--s3 {{service.customCssClass}}"
														 *ngIf="vm.submitted && vm.stepInvalid && service.requiredErrorMessage">
														{{ service.requiredErrorMessage }}
													</p>
												</div>
												
												<div *ngIf="service.type === 'DATE'" [style]="service.customCssStyle" class="{{service.customCssClass}}"
														 [ngClass]="{'c-form__group--error': (vm.submitted && vm.stepInvalid)}">
													<label [for]="service.fieldName" class="c-form__label u-osb-xs" [innerHtml]="vm.getSafeHtml(service.label)"></label>
                                                    <div style="max-width: 300px;position:relative;margin-top: 10px;">
	                                                    <input-datepicker-new [id]="service.fieldName"
		                                                    [name]="service.fieldName"
		                                                    [(model)]="vm.selectedServiceIds[service.id]"
		                                                    [hasTimepicker]="false"
		                                                    [hasCalendarIcon]="true"
		                                                    [isSingleDate]="true"
		                                                    [isSmall]="true"
		                                                    [minDate]="vm.minDate ? vm.minDate : null"
		                                                    [isRequired]="vm.required[service.required]">
		                                                </input-datepicker-new>
														<p class="c-text c-text--s3 {{service.customCssClass}}"
															 *ngIf="vm.submitted && vm.stepInvalid && service.requiredErrorMessage">
															{{ service.requiredErrorMessage }}
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div style="min-height:200px;" *ngIf="vm.isSaving">
										<loader-overlay></loader-overlay>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
		<div class="o-grid u-ost-md u-osb-md@up-to-md" *ngIf="!vm.isSaving">
			<div class="o-grid__cell o-grid__cell--w-70@md-and-up u-hidden@up-to-md"></div>
			<div class="o-grid__cell o-grid__cell--w-50@up-to-md o-grid__cell--w-fixed@md-and-up o-grid__cell--right">
				<button id="journeyPreviousStepButton" type="button" (click)="vm.journeyPreviousStep()" class="c-button c-button--link c-button--fit c-button--lg">
					{{'Booking.Button.Back' | translate}}
				</button>
			</div>
			<div class="o-grid__cell o-grid__cell--w-50@up-to-md o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
				<button id="journeyNextStepButton" type="submit" class="c-button c-button--s2 c-button--fit c-button--lg">
					{{'Common.Next' | translate}}
				</button>
			</div>
		</div>
	</div>
</form>
<pre-visit-thank-you *ngIf="vm.showOnlyThankYouSection"
	 [isInitialized]="vm.isInitialized"
	 [isRecordTicketForPerson]="vm.isRecordTicketForPerson"
	 [informationSection]="vm.thankYouInformationSection"
	 [preVisitTicketId]="vm.preVisitTicketId">
</pre-visit-thank-you>
